// import { useEffect, } from 'react';
import { CubeTextureLoader, LinearMipMapLinearFilter, WebGLCubeRenderTarget, CubeCamera, } from 'three';
import { Canvas, useFrame, useThree, extend, } from '@react-three/fiber';
import { useRef } from 'react';
// import { OrbitControls } from '@react-three/drei';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

extend({ OrbitControls });

const CameraControls = () => {
    const { camera, gl: { domElement } } = useThree();

    const controls = useRef();
    useFrame(() => controls.current.update());
    return (
        <orbitControls
            ref={controls}
            args={[camera, domElement]}
            // autoRotate={true}
            enableZoom={false}
        />
    );
};

function TextureBox() {

    const { scene } = useThree();
    const loader = new CubeTextureLoader();

    const texture = loader.load([
        './img/cubemap1/posx.jpg', './img/cubemap1/negx.jpg',
        './img/cubemap1/posy.jpg', './img/cubemap1/negy.jpg',
        './img/cubemap1/posz.jpg', './img/cubemap1/negz.jpg',
    ]);

    scene.background = texture;
    return null;

}

function Sphere() {

    const { scene, gl } = useThree();
    const cubeRenderTarget = new WebGLCubeRenderTarget(256, { // 256; 512 - quality
        // format: RGBFormat,
        generateMipmaps: true,
        minFilter: LinearMipMapLinearFilter,
    });
    const cubeCamera = new CubeCamera(1, 1000, cubeRenderTarget);
    cubeCamera.position.set(0, 0, 0);
    scene.add(cubeCamera);

    useFrame(() => cubeCamera.update(gl, scene));

    return (
        <mesh visible position={[0, 0, 0]} rotation={[0, 0, 0]} castShadow>
            <sphereGeometry attach="geometry" args={[2, 32, 32]} />
            {/* <sphereGeometry attach="geometry" args={[1, 32, 32]} /> */}
            <meshBasicMaterial
                attach="material"
                envMap={cubeCamera.renderTarget.texture}
                color="white"
                roughness={0.1}
                metalness={1}
            />
        </mesh>
    )

}

const Page = () => {

    // useEffect(() => {
    //     document.body.classList.add('_lock');
    //     return () => {
    //         document.body.classList.remove('_lock');
    //     };
    // });

    return (
        // <div className='about'>
        <Canvas>
            {/* <directionalLight intensity={.5} /> */}
            <Sphere />
            <TextureBox />
            <CameraControls />
            {/* <perspectiveCamera
                    fov={70}
                    aspect={window.innerWidth / window.innerHeight}
                    near={1}
                    far={5000}
                    position={[0, 400, 1000]}
                /> */}
            {/* <OrbitControls
                    enableZoom={false}
                /> */}
        </Canvas>
        // {/* </div> */}
    )

};

export default Page;